import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {ICreateSchedulerItemRequest, IEvent, IEventFilterRequest, IEventRequest, ISchedulerItem, ISearchSchedulerItemRequest, IUpdateSchedulerItemRequest} from "../models/scheduler";
import {map, tap} from "rxjs";
import { IPagedResults } from 'src/app/core/models/base';
import { IAbsencePlanning, ISearchAbsenceGroupsRequest } from 'src/app/time-tracking/models/absence-group';

@Injectable({
  providedIn: 'root'
})
export class ResourcePlanerService {

  constructor(private http : HttpClient) { }

  // Every employee's absences for the planning view. Outside the caller's supervisor reach the
  // backend reduces an absence to "absent" (isRedacted: period and state only).
  listAbsences(request: ISearchAbsenceGroupsRequest) {
    return this.http.post<IPagedResults<IAbsencePlanning[]>>(
      `${environment.baseUrl}/v1/scheduleritems/searchAbsenceGroups`,
      request
    );
  }

  listEvents(request : ISearchSchedulerItemRequest){
    return this.http.post<IPagedResults<ISchedulerItem[]>>(
      `${environment.baseUrl}/v1/scheduleritems/searchscheduleritems`,
      request
    ) .pipe(
      map((data) => {
        const response = data;
        response.data.map((event) => {
          event.start = new Date(event.start);
          event.end = new Date(event.end);
        })
        return response;
      })
    )
  }

  addEvent(request : ICreateSchedulerItemRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/scheduleritems/createscheduleritem`,
      request
    )
  }

  updateEvent(request : IUpdateSchedulerItemRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/scheduleritems/updatescheduleritem/${request.id}`,
      request
    )
  }

  deleteEvent(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/scheduleritems/deletescheduleritem/${id}`
    )
  }
}
